import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col } from 'react-bootstrap';

// Import images
import featureImg1 from '../assets/images/feature-img1.png';
import featureImg1Icon1 from '../assets/images/feature-img1-icon1.png';
import featureImg2 from '../assets/images/feature-img2.png';
import featureImg3 from '../assets/images/feature-img3.png';
import arrowIcon from '../assets/images/up-right-arrow.png';

const Features = () => {
    const { t } = useTranslation();

    return (
        <section className="float-left w-100 amazing-features-con position-relative padding-top padding-bottom main-box">
            <Container className="wow animate__animated animate__fadeInUp" data-wow-duration="2s" data-wow-delay="0.2s">
                <div className="heading-title-con text-center">
                    <span className="special-text color-blue d-block wow animate__animated animate__fadeInLeft" data-wow-duration="2s" data-wow-delay="0.2s">{t('features_title')}</span>
                    <h2 className="wow animate__animated animate__fadeInRight" data-wow-duration="2s" data-wow-delay="0.4s" dangerouslySetInnerHTML={{ __html: t('features_subtitle') }}></h2>
                </div>
                <Row className="all_row wow animate__animated animate__fadeIn" data-wow-duration="2s" data-wow-delay="0.4s">
                    <Col lg={4} md={6} className="all_column wow animate__animated animate__fadeInLeft" data-wow-duration="2s" data-wow-delay="0.5s">
                        <div className="feature-box position-relative all_boxes">
                            <h4>{t('feature1_title')}</h4>
                            <p className="mb-0">{t('feature1_desc')}</p>
                            <img src={featureImg1Icon1} alt="feature icon" className="img-fluid position-absolute feature-icon1" />
                            <figure><img src={featureImg1} alt="feature" className="img-fluid" /></figure>
                            <a href="/services"><img src={arrowIcon} alt="arrow" className="img-fluid" /></a>
                        </div>
                    </Col>
                    <Col lg={4} md={6} className="all_column wow animate__animated animate__fadeInLeft" data-wow-duration="2s" data-wow-delay="0.5s">
                        <div className="feature-box position-relative all_boxes bg-green">
                            <h4>{t('feature2_title')}</h4>
                            <p className="mb-0">{t('feature2_desc')}</p>
                            <figure><img src={featureImg2} alt="feature" className="img-fluid" /></figure>
                            <a href="/services"><img src={arrowIcon} alt="arrow" className="img-fluid" /></a>
                        </div>
                    </Col>
                    <Col lg={4} md={6} className="all_column wow animate__animated animate__fadeInLeft" data-wow-duration="2s" data-wow-delay="0.5s">
                        <div className="feature-box position-relative all_boxes">
                            <h4>{t('feature3_title')}</h4>
                            <p className="mb-0">{t('feature3_desc')}</p>
                            <figure><img src={featureImg3} alt="feature" className="img-fluid feature-img3" /></figure>
                            <a href="/services"><img src={arrowIcon} alt="arrow" className="img-fluid" /></a>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default Features;